module.exports = __webpack_public_path__ + "static/media/KaTeX_AMS-Regular.c67be87a.ttf";